import { render, staticRenderFns } from "./schedule_dispense_competition.vue?vue&type=template&id=a5b1cb56&"
import script from "./schedule_dispense_competition.vue?vue&type=script&lang=js&"
export * from "./schedule_dispense_competition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports